define("ember-power-select/components/power-select-multiple", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/utils"], function (_exports, _component, _templateFactory, _component2, _object, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <PowerSelect
    @animationEnabled={{@animationEnabled}}
    @triggerRole={{@triggerRole}}
    @ariaDescribedBy={{@ariaDescribedBy}}
    @ariaInvalid={{@ariaInvalid}}
    @ariaLabel={{@ariaLabel}}
    @ariaLabelledBy={{@ariaLabelledBy}}
    @afterOptionsComponent={{ensure-safe-component @afterOptionsComponent}}
    @allowClear={{@allowClear}}
    @beforeOptionsComponent={{if @beforeOptionsComponent (ensure-safe-component @beforeOptionsComponent) null}}
    @buildSelection={{or @buildSelection this.defaultBuildSelection}}
    @calculatePosition={{@calculatePosition}}
    @closeOnSelect={{@closeOnSelect}}
    @defaultHighlighted={{@defaultHighlighted}}
    @destination={{@destination}}
    @disabled={{@disabled}}
    @dropdownClass={{@dropdownClass}}
    @extra={{@extra}}
    @groupComponent={{ensure-safe-component @groupComponent}}
    @horizontalPosition={{@horizontalPosition}}
    @initiallyOpened={{@initiallyOpened}}
    @loadingMessage={{@loadingMessage}}
    @matcher={{@matcher}}
    @matchTriggerWidth={{@matchTriggerWidth}}
    @noMatchesMessage={{@noMatchesMessage}}
    @noMatchesMessageComponent={{ensure-safe-component @noMatchesMessageComponent}}
    @onBlur={{@onBlur}}
    @onChange={{@onChange}}
    @onClose={{@onClose}}
    @onFocus={{this.handleFocus}}
    @onInput={{@onInput}}
    @onKeydown={{this.handleKeydown}}
    @onOpen={{this.handleOpen}}
    @options={{@options}}
    @optionsComponent={{ensure-safe-component @optionsComponent}}
    @placeholder={{@placeholder}}
    @placeholderComponent={{ensure-safe-component @placeholderComponent}}
    @preventScroll={{@preventScroll}}
    @registerAPI={{@registerAPI}}
    @renderInPlace={{@renderInPlace}}
    @required={{@required}}
    @scrollTo={{@scrollTo}}
    @search={{@search}}
    @searchEnabled={{@searchEnabled}}
    @searchField={{@searchField}}
    @searchMessage={{@searchMessage}}
    @searchPlaceholder={{@searchPlaceholder}}
    @selected={{@selected}}
    @selectedItemComponent={{ensure-safe-component @selectedItemComponent}}
    @eventType={{@eventType}}
    @title={{@title}}
    @triggerClass="ember-power-select-multiple-trigger {{@triggerClass}}"
    @triggerComponent={{
      if
      @triggerComponent
      (component (ensure-safe-component @triggerComponent) tabindex=@tabindex)
      (component "power-select-multiple/trigger" tabindex=@tabindex)
    }}
    @triggerId={{@triggerId}}
    @verticalPosition={{@verticalPosition}}
    @tabindex={{this.computedTabIndex}}
    @ebdTriggerComponent={{ensure-safe-component @ebdTriggerComponent}}
    @ebdContentComponent={{ensure-safe-component @ebdContentComponent}}
    ...attributes as |option select|>
    {{yield option select}}
  </PowerSelect>
  
  */
  {
    "id": "Sj3zuYdT",
    "block": "[[[8,[39,0],[[17,1]],[[\"@animationEnabled\",\"@triggerRole\",\"@ariaDescribedBy\",\"@ariaInvalid\",\"@ariaLabel\",\"@ariaLabelledBy\",\"@afterOptionsComponent\",\"@allowClear\",\"@beforeOptionsComponent\",\"@buildSelection\",\"@calculatePosition\",\"@closeOnSelect\",\"@defaultHighlighted\",\"@destination\",\"@disabled\",\"@dropdownClass\",\"@extra\",\"@groupComponent\",\"@horizontalPosition\",\"@initiallyOpened\",\"@loadingMessage\",\"@matcher\",\"@matchTriggerWidth\",\"@noMatchesMessage\",\"@noMatchesMessageComponent\",\"@onBlur\",\"@onChange\",\"@onClose\",\"@onFocus\",\"@onInput\",\"@onKeydown\",\"@onOpen\",\"@options\",\"@optionsComponent\",\"@placeholder\",\"@placeholderComponent\",\"@preventScroll\",\"@registerAPI\",\"@renderInPlace\",\"@required\",\"@scrollTo\",\"@search\",\"@searchEnabled\",\"@searchField\",\"@searchMessage\",\"@searchPlaceholder\",\"@selected\",\"@selectedItemComponent\",\"@eventType\",\"@title\",\"@triggerClass\",\"@triggerComponent\",\"@triggerId\",\"@verticalPosition\",\"@tabindex\",\"@ebdTriggerComponent\",\"@ebdContentComponent\"],[[30,2],[30,3],[30,4],[30,5],[30,6],[30,7],[28,[37,1],[[30,8]],null],[30,9],[52,[30,10],[28,[37,1],[[30,10]],null],null],[28,[37,3],[[30,11],[30,0,[\"defaultBuildSelection\"]]],null],[30,12],[30,13],[30,14],[30,15],[30,16],[30,17],[30,18],[28,[37,1],[[30,19]],null],[30,20],[30,21],[30,22],[30,23],[30,24],[30,25],[28,[37,1],[[30,26]],null],[30,27],[30,28],[30,29],[30,0,[\"handleFocus\"]],[30,30],[30,0,[\"handleKeydown\"]],[30,0,[\"handleOpen\"]],[30,31],[28,[37,1],[[30,32]],null],[30,33],[28,[37,1],[[30,34]],null],[30,35],[30,36],[30,37],[30,38],[30,39],[30,40],[30,41],[30,42],[30,43],[30,44],[30,45],[28,[37,1],[[30,46]],null],[30,47],[30,48],[29,[\"ember-power-select-multiple-trigger \",[30,49]]],[52,[30,50],[50,[28,[37,1],[[30,50]],null],0,null,[[\"tabindex\"],[[30,51]]]],[50,\"power-select-multiple/trigger\",0,null,[[\"tabindex\"],[[30,51]]]]],[30,52],[30,53],[30,0,[\"computedTabIndex\"]],[28,[37,1],[[30,54]],null],[28,[37,1],[[30,55]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[18,58,[[30,56],[30,57]]],[1,\"\\n\"]],[56,57]]]]],[1,\"\\n\"]],[\"&attrs\",\"@animationEnabled\",\"@triggerRole\",\"@ariaDescribedBy\",\"@ariaInvalid\",\"@ariaLabel\",\"@ariaLabelledBy\",\"@afterOptionsComponent\",\"@allowClear\",\"@beforeOptionsComponent\",\"@buildSelection\",\"@calculatePosition\",\"@closeOnSelect\",\"@defaultHighlighted\",\"@destination\",\"@disabled\",\"@dropdownClass\",\"@extra\",\"@groupComponent\",\"@horizontalPosition\",\"@initiallyOpened\",\"@loadingMessage\",\"@matcher\",\"@matchTriggerWidth\",\"@noMatchesMessage\",\"@noMatchesMessageComponent\",\"@onBlur\",\"@onChange\",\"@onClose\",\"@onInput\",\"@options\",\"@optionsComponent\",\"@placeholder\",\"@placeholderComponent\",\"@preventScroll\",\"@registerAPI\",\"@renderInPlace\",\"@required\",\"@scrollTo\",\"@search\",\"@searchEnabled\",\"@searchField\",\"@searchMessage\",\"@searchPlaceholder\",\"@selected\",\"@selectedItemComponent\",\"@eventType\",\"@title\",\"@triggerClass\",\"@triggerComponent\",\"@tabindex\",\"@triggerId\",\"@verticalPosition\",\"@ebdTriggerComponent\",\"@ebdContentComponent\",\"option\",\"select\",\"&default\"],false,[\"power-select\",\"ensure-safe-component\",\"if\",\"or\",\"component\",\"yield\"]]",
    "moduleName": "ember-power-select/components/power-select-multiple.hbs",
    "isStrictMode": false
  });

  let PowerSelectMultiple = (_class = class PowerSelectMultiple extends _component2.default {
    get computedTabIndex() {
      if (this.args.triggerComponent === undefined && this.args.searchEnabled) {
        return '-1';
      } else {
        return this.args.tabindex || '0';
      }
    } // Actions


    handleOpen(select, e) {
      if (this.args.onOpen && this.args.onOpen(select, e) === false) {
        return false;
      }

      this.focusInput(select);
    }

    handleFocus(select, e) {
      if (this.args.onFocus) {
        this.args.onFocus(select, e);
      }

      this.focusInput(select);
    }

    handleKeydown(select, e) {
      if (this.args.onKeydown && this.args.onKeydown(select, e) === false) {
        e.stopPropagation();
        return false;
      }

      if (e.keyCode === 13 && select.isOpen) {
        e.stopPropagation();

        if (select.highlighted !== undefined) {
          if (!select.selected || select.selected.indexOf(select.highlighted) === -1) {
            select.actions.choose(select.highlighted, e);
            return false;
          } else {
            select.actions.close(e);
            return false;
          }
        } else {
          select.actions.close(e);
          return false;
        }
      }
    }

    defaultBuildSelection(option, select) {
      let newSelection = (select.selected || []).slice(0);
      let idx = -1;

      for (let i = 0; i < newSelection.length; i++) {
        if ((0, _utils.isEqual)(newSelection[i], option)) {
          idx = i;
          break;
        }
      }

      if (idx > -1) {
        newSelection.splice(idx, 1);
      } else {
        newSelection.push(option);
      }

      return newSelection;
    }

    focusInput(select) {
      if (select) {
        let input = document.querySelector(`#ember-power-select-trigger-multiple-input-${select.uniqueId}`);

        if (input) {
          input.focus();
        }
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "handleOpen", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocus", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype)), _class);
  _exports.default = PowerSelectMultiple;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PowerSelectMultiple);
});